import { ResourceDetailBuilder } from './builders/resource_detail_builder';
import { ContactCardComponent } from './components/people/contact_card/contact_card';
import { ContactDetailComponent } from './components/people/contact_detail/contact_detail_controller';
import { ContactListComponent } from './components/people/contact_list/contact_list_controller';
import { ContactTileAvailabilityComponent } from './components/people/contact_tile_availability/contact_tile_availability_controller';
import { ResourceDetailContentComponent } from './components/places/resource_detail_content/resource_detail_content';
import { ResourceDetailItemComponent } from './components/places/resource_detail_item/resource_detail_item';
import { ContactsListQuery } from './queries/contacts_list_query';
import { ContactsByRelationQuery } from './queries/contacts_relationship_query';
import { ContactsSearchQuery } from './queries/contacts_search_query';
import { ResourceCategoryQuery } from './queries/resource_category_query';
import { ResourceListQuery } from './queries/resource_list_query';
import { ResourceSearchQuery } from './queries/resource_search_query';
import { LocationLinkBuilderServant } from './servants/location_link_builder_servant';
import { ResourceListServant } from './servants/resource_list_servant';
import { ContactListService } from './services/contact_list_service';
import { ContactSearchService } from './services/contact_search_service';
import { ContactsService } from './services/contact_service';
import { ContactToggleService } from './services/contact_toggle_service';
import { ResourceSearchService } from './services/resource_search_service';
import { ResourceTabEnum } from './types/resource_tab_enum';

angular
  .module('capability-ng-resources', [
    'ngSanitize',
    'utility-ng-enumeration',
    'utility-ng-interface',
    'utility-ng-pipeline',
    'ui-ng-delegate',
    'ui-ng-calendar-time',
    'utility-ng-auth-token'
  ])
  .component('contactCard', new ContactCardComponent())
  .component('resourceDetailContent', new ResourceDetailContentComponent())
  .component('resourceDetailItem', new ResourceDetailItemComponent())
  .component('contactDetail', new ContactDetailComponent())
  .component('contactList', new ContactListComponent())
  .component('contactTileAvailability', new ContactTileAvailabilityComponent())
  .service('ngResourceListQuery', ResourceListQuery)
  .service('ngResourceCategoryQuery', ResourceCategoryQuery)
  .service('ngResourceDetailBuilder', ResourceDetailBuilder)
  .service('ngResourceListServant', ResourceListServant)
  .factory('ResourceTabEnum', ResourceTabEnum)
  .service('ngContactListService', ContactListService)
  .service('ngContactSearchService', ContactSearchService)
  .service('ngResourceSearchService', ResourceSearchService)
  .service('ngContactsService', ContactsService)
  .service('ngContactToggleService', ContactToggleService)
  .service('locationLinkBuilderServant', LocationLinkBuilderServant)
  .service('ngContactsByRelationQuery', ContactsByRelationQuery)
  .service('ngContactsListQuery', ContactsListQuery)
  .service('ngContactsSearchQuery', ContactsSearchQuery)
  .service('ngResourceSearchQuery', ResourceSearchQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/capability_ng_resources_module.ts